import React from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: !!error };
  }

  componentDidCatch(error, errorInfo) {
    const { onError } = this.props;
    typeof onError === 'function' && onError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // TODO: discuss the possibility of having some sort of UI fallback
      // for the cases where the ErrorBoundaries are used. Maybe we could
      // explain the concept to a designer to get some insights
      return null;
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.object,
  onError: PropTypes.func,
};
